export default __webpack_public_path__ + "static/media/github.0febe216.svg";